module.exports = __webpack_public_path__ + "static/media/apr2025_austrelia.74e14bc0.webp";